export default function DtoType(ItemType, isNull = false) {
  return function DtoType(data) {
    if (isNull) {
      return data ? new ItemType(data) : null;
    }
    return new ItemType(data);
  };
}
